'use client';

import { useGetSiteOfCareTypesQuery } from 'src/api/redux';
import type { SiteOfCareType } from 'src/api/redux/suggestions/suggestionsApi';

interface UseSocOptionsResult {
  socOptions: SiteOfCareType[];
  isLoading: boolean;
}

const useSocOptions = (): UseSocOptionsResult => {
  const { data, isLoading } = useGetSiteOfCareTypesQuery();
  return { socOptions: data ?? [], isLoading };
};

export default useSocOptions;
